/**
 * Randomize elements within an array
 * Source: https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
 */
const shuffle = <T extends unknown[]>(arr: T): T => {
  // Element indexes
  let current = arr.length;
  let random: number;

  while (current > 0) {
    // Pick index of one of the remaining elements which will still be in order
    random = Math.floor(Math.random() * current);
    // Reduce current index for next loop, stopping _before_ the first element
    current -= 1;
    // Swap that random element with the current element
    // eslint-disable-next-line no-param-reassign
    [arr[current], arr[random]] = [arr[random], arr[current]];
  }

  return arr;
};

export { shuffle };
